<script setup lang="ts">

const { title = '' } = defineProps<{
    title?: string
}>()
</script>

<template>
    <!-- eslint-disable -->
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{{ title }}</title>
        <path d="M1.32612 19.5013C-0.134758 8.00111 20.3168 0.501331 22.7515 15.5013" stroke="#708A9D" stroke-width="2.5" stroke-linecap="round"/>
        <circle cx="11.5015" cy="7.5" r="3.5" fill="#1C2F3C"/>
    </svg>
    <!-- eslint-enable -->
</template>
